import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { LocaleId } from '@trimble-gcs/i18n-types';

export class SetLocale {
  static readonly type = '[LocaleState] SetLocale';
  constructor(public readonly locale: LocaleId) {}
}

export interface LocaleStateModel {
  locale: LocaleId;
}

@State<LocaleStateModel>({
  name: 'localeState',
  defaults: {
    locale: 'af-ZA', // Default used for testing in standalone.
  },
})
@Injectable()
export class LocaleState {
  @Selector() static locale(state: LocaleStateModel): LocaleId {
    return state.locale;
  }

  @Action(SetLocale) setLocale(ctx: StateContext<LocaleStateModel>, { locale }: SetLocale) {
    ctx.patchState({ locale });
  }
}
